// import React from "react";
import { siteData } from "../data/siteData";
import SectionTitle from "../common/SectionTitle";
import FeatureCard from "../common/FeatureCard";
import {
  Leaf,
  Wind,
  Flower,
  Home,
  Sunrise,
  MapPin,
  ShieldCheck
} from "lucide-react";
import { motion } from "framer-motion";

/* ICON MAP */
const iconMap = {
  Leaf,
  Wind,
  Flower,
  Home,
  Sunrise,
  MapPin,
  ShieldCheck
};

/* ANIMATION VARIANTS */
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.12,
      duration: 0.6,
      ease: "easeOut"
    }
  })
};

const hoverCard = {
  hover: {
    y: -6,
    scale: 1.02,
    transition: { type: "spring", stiffness: 200 }
  }
};

const KeyHighlights = () => {
  return (
    <section className="py-10 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Title */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <SectionTitle
            title="The Heart of Floret Town"
            subtitle="Built on three core pillars that define life here"
          />
        </motion.div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 gap-8 my-10">
          {siteData.pillars.map((pillar, idx) => {
            const Icon = iconMap[pillar.icon];

            return (
              <motion.div
                key={idx}
                custom={idx}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                whileHover="hover"
              >
                <motion.div variants={hoverCard}>
                  <FeatureCard
                    icon={<Icon className="w-10 h-10 text-emerald-600" />}
                    title={pillar.title}
                    description={pillar.description}
                    gradient
                  />
                </motion.div>
              </motion.div>
            );
          })}
        </div>

        {/* Highlights */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteData.highlights.map((item, idx) => {
            const Icon = iconMap[item.icon];

            return (
              <motion.div
                key={idx}
                custom={idx}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                whileHover="hover"
              >
                <motion.div
                  variants={hoverCard}
                  className="bg-gradient-to-br from-emerald-50 to-teal-50 p-6 rounded-xl border border-gray-200
                             hover:border-emerald-300 hover:shadow-xl transition-all"
                >
                  <motion.div
                    className="w-12 h-12 mb-4 rounded-lg bg-emerald-100
                               flex items-center justify-center"
                    whileHover={{ rotate: 5, scale: 1.1 }}
                  >
                    <Icon className="w-6 h-6 text-emerald-600" />
                  </motion.div>

                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600">
                    {item.desc}
                  </p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default KeyHighlights;









// // import React from "react";
// import { siteData } from "../data/siteData";
// import SectionTitle from "../common/SectionTitle";
// import FeatureCard from "../common/FeatureCard";
// import {
//   Leaf,
//   Wind,
//   Flower,
//   Home,
//   Sunrise,
//   MapPin,
//   ShieldCheck
// } from "lucide-react";

// /* ICON STRING → COMPONENT MAP */
// const iconMap = {
//   Leaf,
//   Wind,
//   Flower,
//   Home,
//   Sunrise,
//   MapPin,
//   ShieldCheck
// };

// const KeyHighlights = () => {
//   return (
//     <section className="pb-10 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

//         <SectionTitle
//           title="The Heart of Floret Town"
//           subtitle="Built on three core pillars that define life here"
//         />

//         {/* Pillars */}
//         <div className="grid md:grid-cols-3 gap-8 mb-20">
//           {siteData.pillars.map((pillar, idx) => {
//             const Icon = iconMap[pillar.icon];

//             return (
//               <FeatureCard
//                 key={idx}
//                 icon={<Icon className="w-8 h-8 text-emerald-600" />}
//                 title={pillar.title}
//                 description={pillar.description}
//                 gradient
//               />
//             );
//           })}
//         </div>

//         {/* Highlights */}
//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {siteData.highlights.map((item, idx) => {
//             const Icon = iconMap[item.icon];

//             return (
//               <HighlightCard
//                 key={idx}
//                 icon={<Icon className="w-6 h-6 text-emerald-600" />}
//                 title={item.title}
//                 description={item.desc}
//               />
//             );
//           })}
//         </div>

//       </div>
//     </section>
//   );
// };

// /* Highlight Card */
// const HighlightCard = ({ icon, title, description }) => (
//   <div className="bg-white p-6 rounded-xl border border-gray-200
//                   hover:border-emerald-300 hover:shadow-lg transition-all">

//     <div className="w-12 h-12 mb-4 rounded-lg bg-emerald-100
//                     flex items-center justify-center">
//       {icon}
//     </div>

//     <h4 className="text-lg font-bold text-gray-900 mb-2">{title}</h4>
//     <p className="text-sm text-gray-600">{description}</p>
//   </div>
// );

// export default KeyHighlights;